<template>
  <div class="main">
    <!-- 头部导航栏 -->
    <div class="nav_top" v-if="index">
      <div class="nav">
        <el-menu
          :default-active="this.$route.path"
          router
          mode="horizontal"
          active-text-color="#0e9cf6"
        >
          <el-menu-item
            class="menu_item"
            v-for="(item, i) in navList"
            :key="i"
            :index="item.name"
          >
            {{ item.navItem }}
          </el-menu-item>
        </el-menu>
         <!-- <span @click="shenqing">申请空间</span> -->
      </div>
      <!-- <div class="info" v-if="show1 != false"> -->
        <!-- <img :src="UserInfo.avatar" alt /> -->
        <!-- <div> -->
          <!-- <el-dropdown> -->
          <!-- <div class="el-dropdown-link" @click="infomall">{{UserInfo.user_nicename}}</div> -->
          <!-- <el-dropdown-menu slot="dropdown"> -->
          <!-- <el-dropdown-item @click.native="infomall">{{UserInfo.user_nicename}}</el-dropdown-item> -->
          <!-- <el-dropdown-item> -->
          <!-- <span @click="shenqing">申请空间</span> -->
          <!-- </el-dropdown-item> -->
          <!-- <el-dropdown-item><span @click="skipbtn">切换登录</span></el-dropdown-item> -->
          <!-- </el-dropdown-menu> -->
          <!-- </el-dropdown> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>
    <div class="nav_top" v-else>
      <div @click="fanhui" class="fanhui">返回我的空间</div>
    </div>
  </div>
</template>


<script>
export default {
  props: ["show1"],
  data() {
    return {
      index: true,
      // 默认选中项
      activeName: "mine",
      //   用户信息
      UserInfo: {},
      iteminfo: {},
      navList: [
        { name: "/space/dynamic", navItem: "我的空间" },
        { name: "/space/Every", navItem: "人人通空间" },
        { name: "/space/infomalloc", navItem: "申请空间" },
      ],
      // leibie: [
      //   { name: "普通", type: "0000" },
      //   { name: "学生", type: "0001" },
      //   { name: "教师", type: "0002" },
      //   { name: "校长", type: "0003" },
      //   { name: "家长", type: "0004" },
      // ],
    };
  },
  created() {
    // 获取用户信息、
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      this.index = false;
    }
    // console.log(this.show1);
  },
  methods: {
    infomall() {
      this.$router.push("/space/userifon");
    },
    skipbtn() {
      // localStorage.removeItem("routerstate")
      localStorage.clear();
      window.location.href =
        "http://www.rujiaowang.net/app/login/?" +
        "http://www.rujiaowang.net/space/#/dynamic";
    },
    // shenqing() {
    //   this.$router.push("/space/infomalloc");
    // },
    fanhui() {
      localStorage.removeItem("iteminfo");
      this.$router.push("/space/dynamic");
    },
  },
};
</script>


<style lang="less" scoped>
// .nav .el-menu{
//   // background: #4ca0ee !important
// }
.nav{
  margin-right: 200px;
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-menu-item {
  font-size: 16px !important;
  color: #969494 !important;
}
.nav .is-active {
  color: rgb(75, 108, 177) !important;
  border-bottom: none;
}
.nav .el-menu {
  li {
    background: #f5f5f5 !important;
  }
}

.el-menu-item {
  padding: 0 20px;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  position: relative;
  border-bottom: none;
}
.nav_top {
  height: 60px;
  width: 100%;
  // background-color: #eeb54c;
  text-align: center;

  line-height: 60px;
  position: relative;
  .fanhui {
    cursor: pointer;
  }
  span {
    cursor: pointer;
    &:first-child {
      margin-right: 80px;
    }
  }
  .info {
    
    position: absolute;
    height: 60px;
    line-height: 60px;
    top: 0;
    right: 25%;
    img {
      width: 42px;
      height: 42px;
      border: solid 1px rgba(255, 255, 255, 0.46);
      border-radius: 50%;
      overflow: hidden;
      margin-top: 8px;
      vertical-align: top;
    }
    div {
      display: inline-block;
      text-align: center;
      .el-dropdown {
        width: 90px;
        font-size: 16px;
      }
      .el-dropdown-link {
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
.el-dropdown-menu__item {
  min-width: 50px;
  text-align: center;
}
.nav_top {
  .el-tab-pane {
    color: #fff;
    font-size: 16px;
  }

  .nav {
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
  }

  .el-tabs__item.is-active {
    color: #fff !important;
    font-size: 16px;
  }
  .el-tabs__item {
    color: #ddd !important;
    font-size: 16px !important;
  }
  .el-tabs__nav .el-tabs__active-bar {
    background-color: #fff;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item .el-tabs__item {
    padding: 0 40px;
  }
  .el-tabs .el-tabs__content {
    display: none;
  }
}
.el-dropdown-item {
  cursor: pointer;
}
</style>